import './_style.scss'
import Listener from '../../core/watcher/Listener'

Listener.onLoadDOM(() => {
   const screenWidth = window.screen.width

   let ps = document.getElementsByClassName('countries__block')

   function open(e) {
      let child = e.currentTarget.querySelector('.countries__list')

      if (child.classList.contains('countries__list')) {
         child.classList.toggle('countries__listOpen')
      }
   }

   if (screenWidth < 768) {
      for (var i = 0; i < ps.length; i++) {
         ps[i].addEventListener('click', open, false)
      }
   }
})